import pressHeader from "./pressHeader";
import libraryHeader from "./libraryHeader";
import standaloneHeader from "./standaloneHeader";

export default `
${pressHeader}
${libraryHeader}
${standaloneHeader}
`;
